import React from 'react';
import { AutocompleteChangeReason } from "@mui/material";
import { AutocompleteOption } from "../../../../SortFilter/interfaces";
import { StateAutocomplete } from "../../StandardEnumSelects/StateAutocomplete";


type BoundStateAutocompleteProps<T> = {
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundStateAutocomplete = <T,>({
  name,
  value = '',
  onChange
}: BoundStateAutocompleteProps<T>) => {

  const handleChange = (_event: any, newValue: AutocompleteOption, reason: AutocompleteChangeReason) => {
    if (reason !== 'createOption') {
      onChange({
        [name]: newValue?.id ?? ''
      } as unknown as T);
    }
  };

  return <StateAutocomplete
    value={value}
    onChange={handleChange}
  />
}

export { BoundStateAutocomplete };